import {AsyncStatusesEnum} from '../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {useAppQuery} from '../../../../libs/shared/core/src/services/query/useAppQuery';
import {vacationResponderQueries} from '../queries';

/*
 * Hook.
 */

export function useVacationResponderFormQuery(vacationResponderId: number) {
  const {data, asyncStatus, isFetchedAfterMount, refetch} = useAppQuery(
    vacationResponderQueries.byId(vacationResponderId),
  );

  // Don't use stale data to initialize form values.
  return {
    vacationResponder: isFetchedAfterMount ? data : undefined,
    asyncStatus: isFetchedAfterMount ? asyncStatus : AsyncStatusesEnum.LOADING,
    refetch,
  };
}
